<template>
  <div>
      <div class="grid2col p15" @click="customerAccordion">
        <div class="flex align-middle">
          {{ fullName() }}
        </div>
        <div class="flex justify-between align-middle">
          <img src="../../assets/icons/sms_description.svg" alt=""
               @click="sendDescriptionSms">
          <img v-show="customer.attended" src="../../assets/icons/showing_attended.svg" alt=""
               @click="markAsAssisted"
               class="attended-icon">
          <img v-show="!customer.attended" src="../../assets/icons/showing_not_attended.svg" alt=""
               @click="markAsAssisted"
               class="attended-icon">
          <img src="../../assets/icons/remove.svg" alt=""
               @click="deleteCustomer" class="remove-icon">
        </div>
      </div>
      <transition name="slide-fade">
        <CustomerAccordion ref="customerExtraFunctions" v-show="showExtra" v-bind:customer="customer" v-bind:customers="customers"></CustomerAccordion>
      </transition>

    <spinner v-show="this.loader"/>
  </div>
</template>

<script>
import deleteShowingsCustomer from '../forms/visningar/deleteCustomer';
import sendDescription from '../forms/visningar/sendDescription';
import CustomerAccordion from './CustomerExtraAccordion';
import spinner from '../spinner';

export default {
  props: {
    customer: {
      type: Object,
    },
    customers: {
      type: Array,
    },
    activityShowing: {
      type: Number,
    },
    showingId: {
      type: Number,
    },
    hasMany: {
      type: Boolean
    }
  },
  data() {
    return {
      showExtra: false,
      loader: false,
    };
  },
  methods: {
    deleteCustomer() {
      let customerInfo = {
        customerId: this.customer.id,
        activityShowingId: this.activityShowing,
        objectShowingId: this.showingId,
        name: this.fullName(),
      };

      this.$store.commit('showing/STORE_CURRENT_DATA_INFO', customerInfo);
      this.$store.commit('STORE_ACTIVE_COMPONENT', deleteShowingsCustomer);
      this.$root.modalOpen = true;
    },
    markAsAssisted() {
      let data = {
        attended: !this.customer.attended,
        objectShowingId: this.showingId,
        activityShowingId: this.activityShowing,
        customerId: this.customer.id,
      };
      let successMessage = this.customer.attended ? 'Kund deltog inte på visningen' : 'Kund deltog på visningen';
      this.loader = true;
      this.$root.callFasAdApi('/internalapi/showing/customer-edit-attended', 'POST', data).then((data) => {
        this.$store.dispatch('showing/storeShowingDataForSelectedListing', {listingId: this.$route.params.id});

        this.$root.handleResponseMessage(data, successMessage);
        this.loader = false;
      }).catch(console.error);
    },
    fullName: function() {
      return this.customer.firstname + ' ' + this.customer.lastname;
    },
    customerAccordion(e) {
      let classes = ['remove-icon', 'attended-icon'];

      if (classes.includes(e.target.classList[0])) {
        return false;
      }
      this.showExtra = !this.showExtra;
      e.currentTarget.parentNode.classList.toggle('active');
      this.$refs.customerExtraFunctions.getCustomerNotes()
      this.$refs.customerExtraFunctions.getObjectNotes()
    },
    sendDescriptionSms() {
      let data = {
        customerId: this.customer.id,
        activityShowingId: this.activityShowing,
        fullName: this.fullName(),
      };

      this.$store.commit('showing/STORE_CURRENT_DATA_INFO', data);
      this.$store.commit('STORE_ACTIVE_COMPONENT', sendDescription);
      this.$root.modalOpen = true;
    },
  },
  components: {
    CustomerAccordion,
    spinner,
  },
};
</script>

<style>
/* durations and timing functions.*/
.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(.39, 1.91, 1, .56);

}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateY(10px);
  opacity: 0;
}

</style>
